import React, { useState } from 'react';
import { grey } from '@mui/material/colors';
import isNil from '../functions/isNil';
import { IQuestion } from './helixIcons';
import { IconButton, Popover, Link, Box } from '@mui/material';
import InlineHelpContent from '../help/inlineHelpContent';
import { useTranslation } from 'react-i18next';

interface Props {
  helpkey: string;
  customContent?: React.ReactNode;
  rootStyle?: React.CSSProperties;
}

export default function InlineHelp(props: Props) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const { t } = useTranslation();

  function handleRequestOpen(e: any) {
    e.preventDefault();
    setOpen(true);
    setAnchorEl(e.target);
  }

  const { helpkey, customContent, rootStyle } = props;
  const content = InlineHelpContent(helpkey) || {
    link: null,
    linkText: null,
  };
  const link = content.link || '';
  const linkText = isNil(content.linkText)
    ? t('Help unavailable')
    : content.linkText;
  const helpContent =
    customContent ||
    (!isNil(link) ? (
      <Link href={link} rel="noopener noreferrer" target="_blank">
        {linkText}
      </Link>
    ) : (
      linkText
    ));

  return (
    <Box
      sx={{ cursor: 'help', verticalAlign: 'middle' }}
      display="inline-block"
      maxWidth={50}
      textAlign="center"
      style={rootStyle || {}}
      data-helpkey={props.helpkey}
    >
      <IconButton
        edge="end"
        onClick={e => handleRequestOpen(e)}
        className="material-icon-button"
        size="large">
        <IQuestion sx={{ color: grey[400] }} />
      </IconButton>
      <Popover
        sx={{ p: 20 }}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {<Box className="ape-help-link">{helpContent}</Box>}
      </Popover>
    </Box>
  );
}
